export default __webpack_public_path__ + "static/Plots0079-15016bafc9c4d2e9c327ac755c89ab8a.jpg";